import {APIClient} from "../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();
//Users
export const getUsers = (filters: any) => api.get(`${url.users}?${filters}`);
export const createUser = (user: any) => api.create(url.users, user);
export const updateUser = (user: any) =>
    api.put(`${url.users}/${user.id}`, user);
export const deleteUser = (id: any) => api.delete(`${url.users}/${id}`);
export const exportUsers = (filters: any) => api.download(url.exportUsers, filters);
